/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from "./SingleProductForm.module.scss";
import primaryComponents, { AsyncSelectField } from "../../primaryComponents";
import { Validation } from "./Validation";
import useSingleProductForm from "./useSingleProductForm";
import Icon from "../../../assets/icons";
import { useEffect, useState } from "react";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "..";
import {
  ArrowCircle,
  DeleteIcon,
  Demacator,
  ExclamationCirlce,
  ImagePlaceHolder,
  PlusCircle,
} from "../../../assets/svgIcons";
import { PricingWarning, WarningDialog } from "../../common";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";
import { Vatform } from "./VatForm";
import { CategoryGroup } from "./CategoryGroup";
import { MarketPlaceCreation } from "./MarketPlaceCreation";
import ProductImageUploader from "../ProductImageUploader";
import { useParams } from "react-router-dom";

const SingleProductForm = ({
  isEditMode = false,
  productDetails = null,
  isUpdatingProduct = false,
  handleProductUpdate = () => {},
}) => {
  const navigate = useNavigate();
  const {
    productImages,
    booleanLabel,
    rootFormDetails,
    storeList,
    isUploadingImage,
    variantProperties,
    storeProperties,
    stockUnits,
    isLoadingStockUnit,
    pricingTypes,
    isLoadingPricingTypes,
    sections,
    isLoadingSections,
    variantImgRef,
    modalViews,
    detectedPricing,
    loadOptions,
    resetModalViews,
    setProductImages,
    handleDeleteVariantFromBackend,
    setStoreProperties,
    setVariantProperties,
    addNewVariantOption,
    applyVariantPricingAcrossStores,
    setRootFormDetails,
    handleVariantImageUpload,
    createOrUpdateProduct,
    setIsStorePropertiesUpdated,
    setIsVariantPropertiesUpdated,
    deleteVariantProperty,
    addNewPricingForStoreProperty,
    removePricingForStoreProperty,
    addNewPricingPropertyForVariantStoreProperty,
    removePricingPropertyForVariantStoreProperty,
    handleMultipleImageUpload,
    deleteImage,
    addAdditionalUnit,
    deleteAdditionalUnit,
    reorderImages,
    // isLoadingReorderImages,
  } = useSingleProductForm({ isEditMode, productDetails, handleProductUpdate });

  const validation = Validation({
    rootFormDetails,
    storeProperties,
    variantProperties,
    additionalUnit: rootFormDetails?.additional_units,
  });

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    trigger,
    setValue,
  } = validation;

  const [showVatOverrideModal, setShowVatOverrideModal] = useState(false);
  useEffect(() => {
    window.setProductFormValue = setValue;
  }, []);
  const params = useParams();
  // Sync VAT values for each store in edit mode
  useEffect(() => {
    // Only run in edit mode when both stores and storeList are available
    if (!isEditMode || !rootFormDetails?.stores?.length || !storeList?.length)
      return;

    // Map through each store in the form and update its VAT from the master storeList
    const updatedStores = rootFormDetails.stores.map((store) => {
      // Find the matching store in storeList by id or value
      const match = storeList.find(
        (s) =>
          s.id === store.value || s.value === store.value || s.id === store.id,
      );
      // If a match is found and it has a VAT, update the VAT; otherwise, keep the original
      return match && match.vat !== undefined
        ? { ...store, vat: match.vat }
        : store;
    });

    // Only update state if any VAT value has changed
    const hasChanged = updatedStores.some(
      (s, i) => s.vat !== rootFormDetails.stores[i].vat,
    );
    if (hasChanged) {
      setRootFormDetails((prev) => ({ ...prev, stores: updatedStores }));
    }
  }, [isEditMode, rootFormDetails?.stores, storeList]);

  useEffect(() => {
    if (productDetails) {
      setProductImages(productDetails?.media_files);
      setRootFormDetails((prev) => ({
        ...prev,
        media_files: productDetails?.media_files || [],
      }));
    }
  }, [productDetails]);
  return (
    <>
      <form
        className={`mt-4 ${globalStyles.cardWithBorder}`}
        id="productForm"
        onSubmit={handleSubmit(createOrUpdateProduct)}
      >
        <div className={styles.topFormSection}>
          <div className={styles.topFormSection__left}>
            {/* product name */}
            <primaryComponents.InputFieldV2
              name="productName"
              control={control}
              register={register}
              placeholder={"Enter product name"}
              classNames="white"
              label="Product Name"
              value={rootFormDetails.name}
              isRequired
              errorMessage={errors?.productName}
              onKeyUp={() => errors?.productName && trigger("productName")}
              onChange={({ target: { value } }) => {
                setRootFormDetails((prevState) => ({
                  ...prevState,
                  name: value,
                }));
              }}
            />

            {/* category field */}
            <CategoryGroup
              validation={validation}
              rootFormDetails={rootFormDetails}
              setRootFormDetails={setRootFormDetails}
            />

            {/* store field */}
            <primaryComponents.MultipleSelectFieldV2
              name="stores"
              control={control}
              options={storeList}
              isRequired={true}
              includeSelectAll={true}
              value={rootFormDetails.stores}
              Creatable={true}
              placeholder="Select store..."
              errorMessage={errors?.stores}
              idKey="id"
              nameKey="name"
              label="Select Store To Make Product Available At"
              onChange={(values) => {
                // Attach VAT from storeList to each selected store
                const storesWithVat = values.map((selectedStore) => {
                  const matchedStore = storeList.find(
                    (store) => store.id === selectedStore.value,
                  );
                  return {
                    ...selectedStore,
                    vat: matchedStore?.vat,
                  };
                });

                setRootFormDetails((prevState) => ({
                  ...prevState,
                  stores: storesWithVat,
                  // Optionally, set the VAT field to the first selected store's VAT or 0
                  // vat: storesWithVat[0]?.vat,
                }));

                if (rootFormDetails?.has_variant)
                  setIsVariantPropertiesUpdated(true);
                else setIsStorePropertiesUpdated(true);
              }}
            />
            <div
              className={`${globalStyles.cardWithBorder} light-bg`}
              style={{ gap: "20px" }}
            >
              <div className="d-flex justify-content-between">
                <p className="small-text-size">Product unit</p>
                <span
                  className="d-flex align-items-center purple--text small-text-size cursor-pointer"
                  onClick={() => resetModalViews("isCreateUnit")}
                >
                  <PlusCircle />
                  <span className="ml-2">Create New Unit</span>
                </span>
              </div>

              <primaryComponents.SelectFieldV2
                label={
                  <span>
                    <span className="d-block">Base Unit</span>
                    <span className="smallest-text-size gray--text">
                      Select the smallest possible unit you will be selling this
                      product in
                    </span>
                  </span>
                }
                name="unit"
                control={control}
                value={rootFormDetails.unit?.label || "Select..."}
                options={stockUnits}
                nameKey="unit"
                idKey="id"
                classNames="w-100"
                floatError={false}
                onChange={(value, label) => {
                  setRootFormDetails((prevState) => ({
                    ...prevState,
                    unit: { value, label },
                  }));
                }}
                isSearchable={true}
                isDisabled={isLoadingStockUnit}
              />

              {rootFormDetails?.additional_units?.length > 0 ? (
                <div className={`${globalStyles.cardWithBorder} white`}>
                  <div className="mx-auto warning px-3 py-2 mb-3">
                    <p
                      className="d-flex small-text-size mb-0 align-items-center"
                      style={{ gap: "5px" }}
                    >
                      <ExclamationCirlce stroke={"#000"} />
                      <span className="ml-1 error--text">Tip: </span>
                      <i>(Additional unit) </i>
                      <span> Carton = 24 pieces</span>
                      <i>(Equivalence)</i>
                    </p>
                  </div>

                  <div className={styles.additionalUnit}>
                    <div>
                      <p className="dark--text small-text-size">
                        Additional Unit
                      </p>
                      <p
                        className="smallest-text-size"
                        style={{ maxWidth: "200px" }}
                      >
                        What other unit do you want to sell this product in?
                      </p>
                    </div>
                    <div>
                      <p className="dark--text small-text-size">Equivalence</p>
                      <p
                        className="smallest-text-size"
                        style={{ maxWidth: "200px" }}
                      >
                        How many base units make up one additional unit?
                      </p>
                    </div>
                  </div>

                  {rootFormDetails?.additional_units?.map(
                    (additional_unit, index) => (
                      <div
                        className={styles.additionalUnit}
                        key={additional_unit?.uuidv4}
                      >
                        <div className="w-100" style={{ minWidth: "200px" }}>
                          <primaryComponents.SelectFieldV2
                            control={control}
                            name={`additionalUnit.${index}.unit`}
                            value={
                              stockUnits?.find(
                                (unitItem) =>
                                  `${unitItem?.id}` ===
                                  `${additional_unit?.unit}`,
                              )?.unit || "Add unit"
                            }
                            options={stockUnits}
                            nameKey="unit"
                            idKey="id"
                            classNames="white"
                            onChange={(value) => {
                              const newAdditionalUnits = [
                                ...rootFormDetails?.additional_units,
                              ];
                              newAdditionalUnits[index].unit = value;
                              setRootFormDetails((prevState) => ({
                                ...prevState,
                                additional_units: newAdditionalUnits,
                              }));
                            }}
                            errorMessage={errors?.additionalUnit?.[index]?.unit}
                            isSearchable={true}
                            isDisabled={isLoadingStockUnit}
                          />
                        </div>
                        <span className="mt-3">
                          <Demacator />
                        </span>
                        <div className="w-100">
                          <primaryComponents.PercentageInputFieldV2
                            name={`additionalUnit.${index}.value`}
                            percentLabel={rootFormDetails?.unit?.label}
                            percentBg={"#e4dafc"}
                            percentColor={"#7647ee"}
                            control={control}
                            classNames="white"
                            placeholder="Enter Value"
                            type="number"
                            step={0.01}
                            min={0.01}
                            value={
                              rootFormDetails?.additional_units?.[index]?.value
                            }
                            errorMessage={
                              errors?.additionalUnit?.[index]?.value
                            }
                            onKeyUp={() =>
                              errors?.additionalUnit?.[index]?.value &&
                              trigger(`additionalUnit.${index}.value`)
                            }
                            onChange={({ target: { value } }) => {
                              const newAdditionalUnits = [
                                ...rootFormDetails?.additional_units,
                              ];
                              newAdditionalUnits[index].value = value;
                              setRootFormDetails((prevState) => ({
                                ...prevState,
                                additional_units: newAdditionalUnits,
                              }));
                            }}
                          />
                        </div>

                        <span
                          className="ml-2 cursor-pointer"
                          style={{ marginTop: "12px" }}
                          onClick={() => {
                            deleteAdditionalUnit(index);
                          }}
                        >
                          <DeleteIcon />
                        </span>
                      </div>
                    ),
                  )}
                </div>
              ) : null}

              <div
                className="d-flex justify-content-between align-items-end"
                style={{ gap: "10px" }}
              >
                <secondaryComponents.ToolTipV2
                  tipText="Additional unit allows you to sell one product in multiple units. E.g. sell a product in cartons, dozens & pieces."
                  position="bottom"
                  maxWidth="300px"
                >
                  <span
                    className="smallest-text-size purple--text"
                    style={{ textDecoration: "underline" }}
                  >
                    What is Additional Unit
                  </span>
                </secondaryComponents.ToolTipV2>
                <primaryComponents.Button
                  classNames={"btn btn--outline smallBtn"}
                  type="button"
                  onClick={() => addAdditionalUnit()}
                  isDisabled={
                    !rootFormDetails?.unit || rootFormDetails?.unit === ""
                  }
                >
                  <PlusCircle />
                  <span className="ml-2">Add Additional Unit</span>
                </primaryComponents.Button>
              </div>
            </div>

            {/* <div
              className={`${globalStyles.cardWithBorder} light-bg`}
              style={{ gap: "20px" }}
            >
              <div className="d-flex justify-content-between">
                <p className="small-text-size">VAT</p>
              </div>

              <div className={styles.vatContainer}>
                <div>
                  <div
                    className="d-flex mb-4 justify-content-center align-items-center p-1"
                    style={{
                      gap: "4px",
                      background: "#fff",
                      borderRadius: "16px",
                      minHeight: "15px",
                      width: "320px",
                    }}
                  >
                    <div
                      className="d-flex flex-wrap align-items-center"
                      style={{ gap: "12px" }}
                    >
                      <div
                        className="d-flex flex-wrap align-items-center"
                        style={{ gap: "4px" }}
                      >
                        <span style={{ fontSize: "13px" }}>
                          Enable VAT for this product:
                        </span>
                        <primaryComponents.RadioButton
                          name="vatEnabled"
                          value={true}
                          id="vat-yes"
                          checked={rootFormDetails.vat_enabled}
                          setRadioValue={() => {
                            // Check if any selected store has VAT > 0
                            const hasStoreVat = (
                              rootFormDetails?.stores || []
                            ).some(
                              (store) => store.vat && Number(store.vat) > 0,
                            );
                            if (hasStoreVat) {
                              setShowVatOverrideModal(true);
                            } else {
                              setRootFormDetails((prev) => ({
                                ...prev,
                                vat_enabled: true,
                              }));
                              setShowVatOverrideModal(false);
                            }
                          }}
                          classNames="whites"
                          isControlled={true}
                        />
                        <span style={{ fontSize: "13px" }}>Yes</span>
                      </div>

                      <div
                        style={{
                          width: "2px",
                          height: "20px",
                          backgroundColor: "#ccc",
                        }}
                      ></div>

                      <div
                        className="d-flex flex-wrap align-items-center"
                        style={{ gap: "4px" }}
                      >
                        <primaryComponents.RadioButton
                          name="vatEnabled"
                          value={false}
                          id="vat-no"
                          checked={!rootFormDetails.vat_enabled}
                          setRadioValue={() =>
                            setRootFormDetails((prev) => ({
                              ...prev,
                              vat_enabled: false,
                              vat: 0,
                            }))
                          }
                          classNames="whites"
                          isControlled={true}
                        />
                        <span style={{ fontSize: "13px" }}>No</span>
                      </div>
                    </div>
                  </div>

                  {rootFormDetails.vat_enabled && (
                    <div
                      style={{
                        padding: "0 18px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span style={{ fontSize: "13px" }}>
                          Include VAT in selling price.
                        </span>
                        <primaryComponents.Checkbox
                          id="include-vat-in-price"
                          name="includeVatInPrice"
                          isChecked={rootFormDetails.include_vat_in_price}
                          onChange={(checked) =>
                            setRootFormDetails((prev) => ({
                              ...prev,
                              include_vat_in_price: checked,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="w-40">
                  <primaryComponents.PercentageInputFieldV2
                    name="vat"
                    control={control}
                    percentBg={"#E4DAFC"}
                    percentColor={"#7647EE"}
                    classNames="border-0 bg-gray-300 focus-visible:ring-0 focus-visible:ring-offset-0 text-gray-500"
                    placeholder="Enter VAT Value"
                    type="number"
                    min={0}
                    step={0.01}
                    value={rootFormDetails.vat}
                    isDisabled={rootFormDetails.vat_enabled !== true}
                    errorMessage={errors?.vat}
                    onKeyUp={() => errors?.vat && trigger("vat")}
                    onChange={({ target: { value } }) =>
                      setRootFormDetails((prev) => ({
                        ...prev,
                        vat: value,
                      }))
                    }
                  />
                </div>
              </div>
            </div> */}

            <Vatform
              validation={validation}
              rootFormDetails={rootFormDetails}
              setRootFormDetails={setRootFormDetails}
            />

            <secondaryComponents.LoaderHelper
              isLoading={isLoadingSections}
              classNames={"mt-2"}
            >
              {sections?.length > 0 ? (
                <primaryComponents.SelectFieldV2
                  name="section"
                  control={control}
                  label="Select section"
                  value={
                    sections?.find(
                      (section) => section.id === rootFormDetails?.section,
                    )?.name || "Select..."
                  }
                  options={sections}
                  nameKey="name"
                  idKey="id"
                  classNames="w-100"
                  onChange={(value) => {
                    setRootFormDetails((prevState) => ({
                      ...prevState,
                      section: value,
                    }));
                  }}
                  isSearchable={true}
                />
              ) : null}
            </secondaryComponents.LoaderHelper>

            <div className={styles.flexArrange}>
              {/* has variants */}
              <primaryComponents.SelectFieldV2
                classNames="w-100"
                name="hasVariants"
                control={control}
                label="Does This Product Have Variants?"
                isRequired={true}
                value={booleanLabel[rootFormDetails.has_variant]}
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
                nameKey="label"
                idKey="value"
                onChange={(value) => {
                  setRootFormDetails((prevState) => ({
                    ...prevState,
                    has_variant: value,
                  }));
                  if (value) setIsVariantPropertiesUpdated(true);
                  else setIsStorePropertiesUpdated(true);
                }}
                isSearchable={false}
                errorMessage={errors?.hasVariants}
              />

              {/* show on sell-mode */}
              <primaryComponents.SelectFieldV2
                classNames="w-100"
                name="showProductOnSellMode"
                control={control}
                label="Show this product in sell mode?"
                isRequired={true}
                value={booleanLabel[rootFormDetails.show_product_in_sell_mode]}
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
                nameKey="label"
                idKey="value"
                onChange={(value) => {
                  setRootFormDetails((prevState) => ({
                    ...prevState,
                    show_product_in_sell_mode: value,
                  }));
                }}
                isSearchable={false}
              />
            </div>
            <div>
              <div className="d-flex justify-content-between mb-2">
                <p className="small-text-size dark--text">Product’s Supplier</p>
                <span
                  className="d-flex justify-content-end align-items-center purple--text small-text-size cursor-pointer"
                  onClick={() => resetModalViews("isCreateSupplier")}
                >
                  <PlusCircle />
                  <span className="ml-2">Add Supplier</span>
                </span>
              </div>

              <AsyncSelectField
                control={control}
                name={"supplier"}
                register={register}
                label={"Select supplier"}
                value={rootFormDetails?.supplier_name}
                nameKey={"name"}
                idKey={"id"}
                loadOptions={loadOptions}
                onChange={(value) => {
                  setRootFormDetails((prev) => ({
                    ...prev,
                    supplier: value,
                  }));
                }}
              />
            </div>

            <div className={styles.flexArrange}>
              {/* product sku */}
              <primaryComponents.InputFieldV2
                name="productSku"
                control={control}
                label="Product SKU"
                placeholder="Enter SKU"
                classNames="white"
                value={rootFormDetails.sku}
                errorMessage={errors?.productSku}
                onKeyUp={() => errors?.productSku && trigger("productSku")}
                onChange={({ target: { value } }) => {
                  setRootFormDetails((prevState) => ({
                    ...prevState,
                    sku: value,
                  }));
                }}
              />
              {/* bar code */}
              {!rootFormDetails.has_variant ? (
                <primaryComponents.InputFieldV2
                  inputIcon={Icon.barCodeIcon}
                  name="barcode"
                  control={control}
                  label="Scan Barcode"
                  placeholder="Scan barcode"
                  classNames="white"
                  value={rootFormDetails.barcode}
                  errorMessage={errors?.barcode}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                    errors?.barcode && trigger("barcode");
                  }}
                  onChange={(e) => {
                    setRootFormDetails((prevState) => ({
                      ...prevState,
                      barcode: e?.target?.value,
                    }));
                  }}
                />
              ) : null}
            </div>

            {/* <primaryComponents.TextAreaV2
                  classNames="white"
                  label="Description"
                  placeholder="Add description to this product"
                  control={control}
                  name="description"
                  value={rootFormDetails?.description}
                  register={register}
                  errorMessage={errors?.description}
                  onKeyUp={() => errors?.description && trigger("description")}
                  onChange={({ target: { value } }) => {
                    setRootFormDetails((prevState) => ({
                      ...prevState,
                      description: value,
                    }));
                  }}
                /> */}
            <div>
              <label>Description</label>
              <ReactQuill
                theme="snow"
                value={rootFormDetails?.description}
                onChange={(content) => {
                  setRootFormDetails((prev) => ({
                    ...prev,
                    description: content,
                  }));
                }}
                placeholder="Add description to this product"
                readOnly={false}
                className={styles.quillEditor}
                modules={{
                  toolbar: [
                    [{ header: "1" }, { header: "2" }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["bold", "italic", "underline"],
                    ["link"],
                  ],
                }}
                formats={[
                  "header",
                  "list",
                  "bold",
                  "italic",
                  "underline",
                  "link",
                ]}
              />
            </div>
          </div>

          {/* profile section */}
          <ProductImageUploader
            images={productImages}
            onImagesChange={setProductImages}
            onUpload={handleMultipleImageUpload}
            onDeleteSaved={deleteImage}
            isUploading={isUploadingImage}
            itemId={String(params?.id)}
            itemType="product"
            onReorder={reorderImages}
          />
        </div>

        {/* display if variant is true */}
        {rootFormDetails?.has_variant ? (
          <h5 className="mt-5">Add Product Variants</h5>
        ) : null}

        <div
          className={`${styles.bottomFormSection} ${rootFormDetails?.has_variant ? "" : styles.showBorder}`}
        >
          {/* product with variants */}
          {rootFormDetails.has_variant ? (
            <>
              {variantProperties?.map((item, variantIndex) => (
                <div
                  className={`${styles.priceCover} ${styles.thickTopBorder}`}
                  key={item?.uuid}
                >
                  <div className={styles.variantOption}>
                    <input
                      style={{ display: "none" }}
                      ref={(el) => (variantImgRef.current[variantIndex] = el)}
                      type="file"
                      name={`variant-img-${variantIndex}`}
                      id={`variant-img-${variantIndex}`}
                      onChange={(params) =>
                        handleVariantImageUpload(params, variantIndex)
                      }
                    />
                    {/* variant image */}
                    <div
                      className={styles.imageContainer}
                      onClick={() =>
                        variantImgRef.current[variantIndex].click()
                      }
                    >
                      {variantProperties[variantIndex]?.image_url ? (
                        <img
                          src={variantProperties[variantIndex]?.image_url}
                          alt="variant"
                        />
                      ) : (
                        <ImagePlaceHolder />
                      )}
                    </div>
                    {/* varaint option */}
                    <primaryComponents.InputFieldV2
                      labelClassNames={"labelHighlightBg"}
                      name={`variantProperties.${variantIndex}.option`}
                      control={control}
                      label="Variant Type"
                      register={register}
                      classNames="white"
                      placeholder="Enter your option eg. size, color, flavor etc"
                      isRequired
                      errorMessage={
                        errors?.variantProperties?.[variantIndex]?.option
                      }
                      onKeyUp={() =>
                        errors?.variantProperties?.[variantIndex]?.option &&
                        trigger(`variantProperties.${variantIndex}.option`)
                      }
                      onChange={({ target: { value } }) => {
                        const newVariantProperties = [...variantProperties];
                        newVariantProperties[variantIndex].option = value;
                        setVariantProperties(newVariantProperties);
                      }}
                    />
                    {/* variant value */}
                    <primaryComponents.InputFieldV2
                      labelClassNames={"labelHighlightBg"}
                      name={`variantProperties.${variantIndex}.value`}
                      control={control}
                      label="Variant Value"
                      register={register}
                      classNames="white"
                      placeholder="Enter your values eg. small, followed by a comma"
                      isRequired
                      errorMessage={
                        errors?.variantProperties?.[variantIndex]?.value
                      }
                      onKeyUp={() =>
                        errors?.variantProperties?.[variantIndex]?.value &&
                        trigger(`variantProperties.${variantIndex}.value`)
                      }
                      onChange={({ target: { value } }) => {
                        const newVariantProperties = [...variantProperties];
                        newVariantProperties[variantIndex].value = value;
                        setVariantProperties(newVariantProperties);
                      }}
                    />

                    {/* bar code */}
                    <primaryComponents.InputFieldV2
                      labelClassNames={"labelHighlightBg"}
                      inputIcon={Icon.barCodeIcon}
                      name={`variantProperties.${variantIndex}.barcode`}
                      control={control}
                      label="Scan Barcode"
                      placeholder="Scan barcode"
                      classNames="white"
                      errorMessage={
                        errors?.variantProperties?.[variantIndex]?.barcode
                      }
                      value={variantProperties?.[variantIndex]?.barcode || ""}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                        errors?.variantProperties?.[variantIndex]?.barcode &&
                          trigger(`variantProperties.${variantIndex}.barcode`);
                      }}
                      onChange={(e) => {
                        const newVariantProperties = [...variantProperties];
                        newVariantProperties[variantIndex].barcode =
                          e?.target?.value;
                        setVariantProperties(newVariantProperties);
                      }}
                    />

                    {/* delete variant btn */}
                    {variantProperties?.length > 1 ? (
                      <button
                        type="button"
                        className="btn btn--outline-red"
                        style={{
                          height: "30px",
                          minWidth: "28px",
                          padding: "0",
                          borderRadius: "3px",
                        }}
                        onClick={() => {
                          deleteVariantProperty(variantIndex);
                          if (item?.id)
                            handleDeleteVariantFromBackend(item?.id);
                        }}
                      >
                        <img src={Icon.deleteIcon} alt="" />
                      </button>
                    ) : null}
                  </div>

                  {/* product with different store price */}
                  {item?.store_properties?.length > 0 ? (
                    <>
                      {item?.store_properties.map(
                        (item, storePropertyIndex) => (
                          <div
                            key={item?.store_id}
                            className={styles.variantStoreCover}
                          >
                            <h6>Enter {item?.store_name || ""} pricing</h6>
                            <div className={`${styles.priceSection}`}>
                              <div
                                style={{
                                  marginRight: "10px",
                                }}
                              >
                                {!(
                                  isEditMode && item?.returned_from_backend
                                ) && (
                                  <primaryComponents.InputFieldV2
                                    name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.cost_price`}
                                    control={control}
                                    type="number"
                                    step={0.01}
                                    label={`Cost Price (${
                                      storeList.find(
                                        (store) => store?.id === item?.store_id,
                                      )?.currency_symbol
                                    })`}
                                    placeholder="0"
                                    classNames="white"
                                    isRequired
                                    floatError={false}
                                    isDisabled={
                                      (variantProperties[variantIndex]
                                        .useSameVariantPricing &&
                                        storePropertyIndex > 0) ||
                                      (isEditMode &&
                                        item?.returned_from_backend)
                                    }
                                    value={
                                      variantProperties[variantIndex]
                                        ?.store_properties?.[storePropertyIndex]
                                        ?.cost_price
                                    }
                                    errorMessage={
                                      errors?.variantProperties?.[variantIndex]
                                        ?.store_properties?.[storePropertyIndex]
                                        ?.cost_price
                                    }
                                    onKeyUp={() =>
                                      errors?.variantProperties?.[variantIndex]
                                        ?.store_properties?.[storePropertyIndex]
                                        ?.cost_price &&
                                      trigger(
                                        `variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.cost_price`,
                                      )
                                    }
                                    onChange={({ target: { value } }) => {
                                      const newVariantProperties = [
                                        ...variantProperties,
                                      ];
                                      newVariantProperties[
                                        variantIndex
                                      ].store_properties[
                                        storePropertyIndex
                                      ].cost_price = value;

                                      setVariantProperties(
                                        newVariantProperties,
                                      );
                                      setIsVariantPropertiesUpdated(true);
                                    }}
                                  />
                                )}
                                {isEditMode && item?.returned_from_backend && (
                                  <div
                                    className="mt-3"
                                    style={{
                                      border: "2px solid #eee",
                                      borderRadius: "6px",
                                      padding: "7px",
                                      minWidth: "180px",
                                    }}
                                  >
                                    <p className="small-text-size mb-2">
                                      Verify <strong>CP</strong> of this item
                                      on:
                                    </p>
                                    <span
                                      className="purple--text cursor-pointer small-text-size d-flex align-items-center"
                                      onClick={() =>
                                        navigate(
                                          pathConstants.INVENTORY_PRODUCTS_BATCH +
                                            `?storeId=${item?.store_id}&query=${rootFormDetails?.name}`,
                                        )
                                      }
                                    >
                                      <span className="mr-2">
                                        {" "}
                                        Product batch page{" "}
                                      </span>{" "}
                                      <ArrowCircle stroke="#000" />
                                    </span>
                                  </div>
                                )}
                              </div>

                              {/* rebate */}
                              <primaryComponents.InputFieldV2
                                name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.rebate`}
                                control={control}
                                type="number"
                                step={0.01}
                                min={0}
                                label="Rebate"
                                placeholder="0"
                                classNames="white"
                                value={
                                  variantProperties[variantIndex]
                                    ?.store_properties?.[storePropertyIndex]
                                    ?.rebate || ""
                                }
                                errorMessage={
                                  errors?.variantProperties?.[variantIndex]
                                    ?.store_properties?.[storePropertyIndex]
                                    ?.rebate
                                }
                                onKeyUp={() =>
                                  errors?.variantProperties?.[variantIndex]
                                    ?.store_properties?.[storePropertyIndex]
                                    ?.rebate &&
                                  trigger(
                                    `variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.rebate`,
                                  )
                                }
                                onChange={({ target: { value } }) => {
                                  const newVariantProperties = [
                                    ...variantProperties,
                                  ];
                                  newVariantProperties[
                                    variantIndex
                                  ].store_properties[
                                    storePropertyIndex
                                  ].rebate = value === "" ? undefined : value;
                                  setVariantProperties(newVariantProperties);
                                }}
                              />

                              {/* stock quantity */}
                              {!isEditMode ? (
                                <primaryComponents.InputFieldV2
                                  name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.stock_quantity`}
                                  control={control}
                                  type="number"
                                  step={0.01}
                                  min={0.01}
                                  label="Initial Stock"
                                  placeholder="0"
                                  classNames="white"
                                  value={
                                    variantProperties[variantIndex]
                                      ?.store_properties?.[storePropertyIndex]
                                      ?.stock_quantity || ""
                                  }
                                  errorMessage={
                                    errors?.variantProperties?.[variantIndex]
                                      ?.store_properties?.[storePropertyIndex]
                                      ?.stock_quantity
                                  }
                                  onKeyUp={() =>
                                    errors?.variantProperties?.[variantIndex]
                                      ?.store_properties?.[storePropertyIndex]
                                      ?.stock_quantity &&
                                    trigger(
                                      `variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.stock_quantity`,
                                    )
                                  }
                                  onChange={({ target: { value } }) => {
                                    const newVariantProperties = [
                                      ...variantProperties,
                                    ];
                                    newVariantProperties[
                                      variantIndex
                                    ].store_properties[
                                      storePropertyIndex
                                    ].stock_quantity =
                                      value === "" ? undefined : value;
                                    setVariantProperties(newVariantProperties);
                                  }}
                                />
                              ) : null}

                              {/* minimum stock */}
                              <primaryComponents.InputFieldV2
                                name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.minimum_stock_quantity`}
                                control={control}
                                type="number"
                                step={0.01}
                                min={0}
                                label="Stock Level Alert"
                                placeholder="0"
                                classNames="white"
                                value={
                                  variantProperties[variantIndex]
                                    ?.store_properties?.[storePropertyIndex]
                                    ?.minimum_stock_quantity || ""
                                }
                                errorMessage={
                                  errors?.variantProperties?.[variantIndex]
                                    ?.store_properties?.[storePropertyIndex]
                                    ?.minimum_stock_quantity
                                }
                                onKeyUp={() =>
                                  errors?.variantProperties?.[variantIndex]
                                    ?.store_properties?.[storePropertyIndex]
                                    ?.minimum_stock_quantity &&
                                  trigger(
                                    `variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.minimum_stock_quantity`,
                                  )
                                }
                                onChange={({ target: { value } }) => {
                                  const newVariantProperties = [
                                    ...variantProperties,
                                  ];
                                  newVariantProperties[
                                    variantIndex
                                  ].store_properties[
                                    storePropertyIndex
                                  ].minimum_stock_quantity =
                                    value === "" ? undefined : value;
                                  setVariantProperties(newVariantProperties);
                                }}
                              />

                              {/* expiry date */}
                              {variantProperties[variantIndex]
                                ?.store_properties?.[storePropertyIndex]
                                ?.stock_quantity > 0 || isEditMode ? (
                                <primaryComponents.DateInputV2
                                  name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.expiry_date`}
                                  control={control}
                                  label="Expiry Date"
                                  placeholder="Enter date"
                                  classNames="white"
                                  value={
                                    variantProperties[variantIndex]
                                      ?.store_properties?.[storePropertyIndex]
                                      ?.expiry_date || ""
                                  }
                                  errorMessage={
                                    errors?.variantProperties?.[variantIndex]
                                      ?.store_properties?.[storePropertyIndex]
                                      ?.expiry_date
                                  }
                                  onKeyUp={() =>
                                    errors?.variantProperties?.[variantIndex]
                                      ?.store_properties?.[storePropertyIndex]
                                      ?.expiry_date &&
                                    trigger(
                                      `variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.expiry_date`,
                                    )
                                  }
                                  onChange={({ target: { value } }) => {
                                    const newVariantProperties = [
                                      ...variantProperties,
                                    ];
                                    newVariantProperties[
                                      variantIndex
                                    ].store_properties[
                                      storePropertyIndex
                                    ].expiry_date =
                                      value === "" ? undefined : value;
                                    setVariantProperties(newVariantProperties);
                                  }}
                                />
                              ) : null}

                              {item?.pricings?.map(
                                (pricingProperty, pricingIndex) => {
                                  const pricingDetailsProperty =
                                    pricingTypes?.find(
                                      (pricingItem) =>
                                        pricingItem?.id ===
                                        pricingProperty?.pricing_type_id,
                                    );

                                  const storeCurrency = storeList.find(
                                    (store) => store?.id === item?.store_id,
                                  )?.currency_symbol;

                                  const realSellingPrice =
                                    rootFormDetails?.include_vat_in_price &&
                                    rootFormDetails?.vat_enabled
                                      ? Number(pricingProperty?.price) /
                                        (1 + Number(rootFormDetails?.vat) / 100)
                                      : Number(pricingProperty?.price);

                                  const discountAmount =
                                    (Number(pricingProperty?.discount_rate) *
                                      realSellingPrice) /
                                    100;

                                  const discountedAmount =
                                    realSellingPrice - discountAmount;

                                  const vatAmount = rootFormDetails?.vat_enabled
                                    ? (Number(discountedAmount) *
                                        Number(rootFormDetails?.vat)) /
                                        100 || 0
                                    : 0;

                                  return (
                                    <>
                                      <div
                                        className={`${styles.priceSection} ${globalStyles.borderTopPurple} ${globalStyles.borderTop} mt-0 pt-3`}
                                        style={{ minWidth: "100%" }}
                                        key={pricingProperty?.uuid}
                                      >
                                        {/* pricing type */}
                                        <secondaryComponents.LoaderHelper
                                          isLoading={isLoadingPricingTypes}
                                          classNames={"mt-2"}
                                        >
                                          <div style={{ maxWidth: "180px" }}>
                                            <label htmlFor="">
                                              <span className="text-danger">
                                                *
                                              </span>

                                              <span>
                                                Price Type
                                                {item?.pricings?.length ===
                                                pricingIndex + 1 ? (
                                                  <>
                                                    {" ( "}
                                                    <span
                                                      className="purple--text"
                                                      style={{
                                                        textDecoration:
                                                          "underline",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        resetModalViews(
                                                          "isCreatePricing",
                                                        )
                                                      }
                                                    >
                                                      Create new
                                                    </span>
                                                    {" )"}
                                                  </>
                                                ) : null}
                                              </span>
                                            </label>
                                            <primaryComponents.SelectFieldV2
                                              name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.pricings.${pricingIndex}.pricing_type_id`}
                                              control={control}
                                              giveControl={false}
                                              value={{
                                                label:
                                                  pricingDetailsProperty?.label,
                                                value:
                                                  pricingDetailsProperty?.id,
                                              }}
                                              options={pricingTypes}
                                              nameKey="label"
                                              idKey="id"
                                              onChange={(value) => {
                                                const newVariantProperties = [
                                                  ...variantProperties,
                                                ];
                                                newVariantProperties[
                                                  variantIndex
                                                ].store_properties[
                                                  storePropertyIndex
                                                ].pricings[
                                                  pricingIndex
                                                ].pricing_type_id = value;
                                                setStoreProperties(
                                                  newVariantProperties,
                                                );
                                                setIsStorePropertiesUpdated(
                                                  true,
                                                );
                                              }}
                                              errorMessage={
                                                errors?.variantProperties?.[
                                                  variantIndex
                                                ]?.store_properties?.[
                                                  storePropertyIndex
                                                ]?.pricings?.[pricingIndex]
                                                  ?.pricing_type_id
                                              }
                                              isDisabled={
                                                (variantProperties[variantIndex]
                                                  .useSameVariantPricing &&
                                                  storePropertyIndex > 0) ||
                                                pricingIndex === 0
                                              }
                                              isSearchable={false}
                                            />
                                          </div>
                                        </secondaryComponents.LoaderHelper>

                                        {/* selling price */}
                                        <div>
                                          <primaryComponents.InputFieldV2
                                            name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.pricings.${pricingIndex}.price`}
                                            control={control}
                                            type="number"
                                            step={0.01}
                                            label={`Selling Amount (${
                                              storeCurrency
                                            })`}
                                            placeholder="0"
                                            classNames="white"
                                            isRequired
                                            isDisabled={
                                              variantProperties[variantIndex]
                                                .useSameVariantPricing &&
                                              storePropertyIndex > 0
                                            }
                                            value={pricingProperty?.price}
                                            errorMessage={
                                              errors?.variantProperties?.[
                                                variantIndex
                                              ]?.store_properties?.[
                                                storePropertyIndex
                                              ]?.pricings?.[pricingIndex]?.price
                                            }
                                            onKeyUp={() =>
                                              errors?.variantProperties?.[
                                                variantIndex
                                              ]?.store_properties?.[
                                                storePropertyIndex
                                              ]?.pricings?.[pricingIndex]
                                                ?.price &&
                                              trigger(
                                                `variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.pricings.${pricingIndex}.price`,
                                              )
                                            }
                                            onChange={({
                                              target: { value },
                                            }) => {
                                              const newVariantProperties = [
                                                ...variantProperties,
                                              ];
                                              newVariantProperties[
                                                variantIndex
                                              ].store_properties[
                                                storePropertyIndex
                                              ].pricings[pricingIndex].price =
                                                value;
                                              setVariantProperties(
                                                newVariantProperties,
                                              );
                                              setIsVariantPropertiesUpdated(
                                                true,
                                              );
                                            }}
                                          />
                                        </div>

                                        {/* discount */}
                                        <primaryComponents.PercentField
                                          label="Discount"
                                          name={`variantProperties.${variantIndex}.store_properties.${storePropertyIndex}.pricings.${pricingIndex}.discount_rate`}
                                          control={control}
                                          isDisabled={
                                            variantProperties[variantIndex]
                                              .useSameVariantPricing &&
                                            storePropertyIndex > 0
                                          }
                                          value={pricingProperty?.discount_rate}
                                          onChange={({ percentValue }) => {
                                            const newVariantProperties = [
                                              ...variantProperties,
                                            ];
                                            newVariantProperties[
                                              variantIndex
                                            ].store_properties[
                                              storePropertyIndex
                                            ].pricings[
                                              pricingIndex
                                            ].discount_rate = percentValue;
                                            setVariantProperties(
                                              newVariantProperties,
                                            );
                                            setIsVariantPropertiesUpdated(true);
                                          }}
                                          dividedValue={
                                            pricingProperty?.price === ""
                                              ? 0
                                              : realSellingPrice
                                          }
                                        />

                                        {pricingIndex > 0 ? (
                                          <div
                                            className="d-flex align-items-center my-auto"
                                            style={{
                                              minWidth: "fit-content",
                                              maxWidth: "fit-content",
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="btn btn--outline-red"
                                              style={{
                                                height: "30px",
                                                width: "28px",
                                                padding: "0",
                                                borderRadius: "3px",
                                              }}
                                              onClick={() =>
                                                removePricingPropertyForVariantStoreProperty(
                                                  pricingIndex,
                                                  storePropertyIndex,
                                                  variantIndex,
                                                )
                                              }
                                            >
                                              <img
                                                src={Icon.deleteIcon}
                                                alt=""
                                              />
                                            </button>
                                          </div>
                                        ) : null}
                                      </div>

                                      <div
                                        className="d-flex flex-wrap pb-2"
                                        style={{
                                          columnGap: "50px",
                                          rowGap: "15px",
                                          minWidth: "auto",
                                          maxWidth: "none",
                                        }}
                                      >
                                        {rootFormDetails?.vat_enabled && (
                                          <>
                                            <div>
                                              <h6>VAT Amount</h6>
                                              <p>
                                                {storeCurrency}
                                                {vatAmount.toFixed(2)}
                                              </p>
                                            </div>

                                            <div>
                                              <h6>
                                                Selling Price (VAT Exclusive)
                                              </h6>
                                              <p>
                                                {storeCurrency}
                                                {discountedAmount.toFixed(2)}
                                              </p>
                                            </div>

                                            <div>
                                              <h6>
                                                Selling Price (VAT Inclusive)
                                              </h6>
                                              <p>
                                                {storeCurrency}
                                                {(
                                                  discountedAmount + vatAmount
                                                ).toFixed(2)}
                                              </p>
                                            </div>
                                          </>
                                        )}

                                        {!isEditMode ? (
                                          <div>
                                            <h6>Profit</h6>
                                            <p>
                                              {storeCurrency}
                                              {(
                                                discountedAmount -
                                                item?.cost_price
                                              ).toFixed(2)}
                                            </p>
                                          </div>
                                        ) : null}
                                      </div>
                                    </>
                                  );
                                },
                              )}
                            </div>

                            <div className={styles.useAcrossSection}>
                              <a
                                className="purple--text"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  addNewPricingPropertyForVariantStoreProperty(
                                    storePropertyIndex,
                                    variantIndex,
                                  )
                                }
                              >
                                + Add another price option
                              </a>
                              {storePropertyIndex === 0 ? (
                                <label
                                  className="d-flex align-items-center"
                                  style={{ cursor: "pointer" }}
                                  htmlFor={`useSameVarianyPricing${variantIndex}`}
                                >
                                  <primaryComponents.Checkbox
                                    name="useSameVariantPricing"
                                    id={`useSameVariantPricing${variantIndex}`}
                                    isChecked={
                                      variantProperties?.[variantIndex]
                                        ?.useSameVariantPricing
                                    }
                                    onChange={(value) => {
                                      applyVariantPricingAcrossStores(
                                        variantIndex,
                                        value,
                                      );
                                    }}
                                  />
                                  <span className="ml-2 mt-1">
                                    Use this pricing properties across other
                                    stores for this variant
                                  </span>
                                </label>
                              ) : null}
                            </div>
                          </div>
                        ),
                      )}
                    </>
                  ) : (
                    <h5 className="text-center my-4">
                      Please select stores to proceed with pricing
                    </h5>
                  )}
                </div>
              ))}
              {/* add variant option */}
              {variantProperties?.length > 0 && (
                <div className={styles.optionContainer}>
                  <a
                    className="purple--text"
                    onClick={() => addNewVariantOption()}
                  >
                    + Add variant
                  </a>
                </div>
              )}
            </>
          ) : (
            // product without variants
            <>
              {storeProperties?.length > 0 ? (
                <>
                  {storeProperties?.map((item, storeIndex) => (
                    <div className={styles.priceCover} key={item.store_id}>
                      <div>
                        <h6>Enter {item?.store_name || ""} pricing</h6>
                        <div
                          className={`align-items-start ${styles.priceSection}`}
                        >
                          {/* cost price */}
                          <div
                            style={{
                              marginRight: "10px",
                            }}
                          >
                            {!(
                              (storeIndex > 0 &&
                                rootFormDetails?.use_same_pricing) ||
                              (isEditMode && item?.returned_from_backend)
                            ) && (
                              <primaryComponents.InputFieldV2
                                name={`storeProperties.${storeIndex}.cost_price`}
                                control={control}
                                type="number"
                                step={0.01}
                                label={`Cost Price (${
                                  storeList.find(
                                    (store) => store?.id === item?.store_id,
                                  )?.currency_symbol
                                })`}
                                placeholder="0"
                                classNames="white"
                                isRequired
                                isDisabled={
                                  (storeIndex > 0 &&
                                    rootFormDetails?.use_same_pricing) ||
                                  (isEditMode && item?.returned_from_backend)
                                }
                                value={storeProperties[storeIndex].cost_price}
                                errorMessage={
                                  errors?.storeProperties?.[storeIndex]
                                    ?.cost_price
                                }
                                onKeyUp={() =>
                                  errors?.storeProperties?.[storeIndex]
                                    ?.cost_price &&
                                  trigger(
                                    `storeProperties.${storeIndex}.cost_price`,
                                  )
                                }
                                onChange={({ target: { value } }) => {
                                  const newStoreProperties = [
                                    ...storeProperties,
                                  ];
                                  newStoreProperties[storeIndex].cost_price =
                                    value;
                                  setStoreProperties(newStoreProperties);
                                  setIsStorePropertiesUpdated(true);
                                }}
                                floatError={false}
                              />
                            )}
                            {isEditMode && item?.returned_from_backend && (
                              <div
                                className="mt-3"
                                style={{
                                  border: "2px solid #eee",
                                  borderRadius: "6px",
                                  padding: "7px",
                                  minWidth: "180px",
                                }}
                              >
                                <p className="small-text-size mb-2">
                                  Verify <strong>CP</strong> of this item on:
                                </p>
                                <span
                                  className="purple--text cursor-pointer small-text-size d-flex align-items-center"
                                  onClick={() =>
                                    navigate(
                                      pathConstants.INVENTORY_PRODUCTS_BATCH +
                                        `?storeId=${item?.store_id}&query=${rootFormDetails?.name}`,
                                    )
                                  }
                                >
                                  <span className="mr-2">
                                    Product batch page{" "}
                                  </span>{" "}
                                  <ArrowCircle stroke="#000" />
                                </span>
                              </div>
                            )}
                          </div>

                          {/* rebate */}
                          <primaryComponents.InputFieldV2
                            name={`storeProperties.${storeIndex}.rebate`}
                            control={control}
                            type="number"
                            step={0.01}
                            min={0}
                            label="Rebate"
                            placeholder="0"
                            classNames="white"
                            value={storeProperties[storeIndex]?.rebate || ""}
                            errorMessage={
                              errors?.storeProperties?.[storeIndex]?.rebate
                            }
                            onKeyUp={() =>
                              errors?.storeProperties?.[storeIndex]?.rebate &&
                              trigger(`storeProperties.${storeIndex}.rebate`)
                            }
                            onChange={({ target: { value } }) => {
                              const newStoreProperties = [...storeProperties];
                              newStoreProperties[storeIndex].rebate =
                                value === "" ? undefined : value;
                              setStoreProperties(newStoreProperties);
                              setIsStorePropertiesUpdated(true);
                            }}
                          />

                          {!isEditMode ? (
                            // stock quantity
                            <primaryComponents.InputFieldV2
                              name={`storeProperties.${storeIndex}.stock_quantity`}
                              control={control}
                              type="number"
                              step={0.01}
                              min={0.01}
                              label="Initial Stock"
                              placeholder="0"
                              classNames="white"
                              value={
                                storeProperties[storeIndex]?.stock_quantity ||
                                ""
                              }
                              errorMessage={
                                errors?.storeProperties?.[storeIndex]
                                  ?.stock_quantity
                              }
                              onKeyUp={() =>
                                errors?.storeProperties?.[storeIndex]
                                  ?.stock_quantity &&
                                trigger(
                                  `storeProperties.${storeIndex}.stock_quantity`,
                                )
                              }
                              onChange={({ target: { value } }) => {
                                const newStoreProperties = [...storeProperties];
                                newStoreProperties[storeIndex].stock_quantity =
                                  value === "" ? undefined : value;
                                setStoreProperties(newStoreProperties);
                                setIsStorePropertiesUpdated(true);
                              }}
                            />
                          ) : null}

                          {/* minimum stock quantity */}
                          <primaryComponents.InputFieldV2
                            name={`storeProperties.${storeIndex}.minimum_stock_quantity`}
                            control={control}
                            type="number"
                            step={0.01}
                            min={0}
                            label="Stock Level Alert"
                            placeholder="0"
                            classNames="white"
                            value={
                              storeProperties[storeIndex]
                                ?.minimum_stock_quantity || ""
                            }
                            errorMessage={
                              errors?.storeProperties?.[storeIndex]
                                ?.minimum_stock_quantity
                            }
                            onKeyUp={() =>
                              errors?.storeProperties?.[storeIndex]
                                ?.minimum_stock_quantity &&
                              trigger(
                                `storeProperties.${storeIndex}.minimum_stock_quantity`,
                              )
                            }
                            onChange={({ target: { value } }) => {
                              const newStoreProperties = [...storeProperties];
                              newStoreProperties[
                                storeIndex
                              ].minimum_stock_quantity =
                                value === "" ? undefined : value;
                              setStoreProperties(newStoreProperties);
                              setIsStorePropertiesUpdated(true);
                            }}
                          />

                          {/* Date input*/}
                          {storeProperties[storeIndex]?.stock_quantity > 0 ||
                          isEditMode ? (
                            <primaryComponents.DateInputV2
                              name={`storeProperties.${storeIndex}.expiry_date`}
                              control={control}
                              label="Expiry Date"
                              placeholder="Expiry date"
                              classNames="white"
                              value={
                                storeProperties?.[storeIndex]?.expiry_date || ""
                              }
                              errorMessage={
                                errors?.storeProperties?.[storeIndex]
                                  ?.expiry_date
                              }
                              onKeyUp={() =>
                                errors?.storeProperties?.[storeIndex]
                                  ?.expiry_date &&
                                trigger(
                                  `storeProperties.${storeIndex}.expiry_date`,
                                )
                              }
                              onChange={({ target: { value } }) => {
                                const newStoreProperties = [...storeProperties];
                                newStoreProperties[storeIndex].expiry_date =
                                  value === "" ? undefined : value;
                                setStoreProperties(newStoreProperties);
                                setIsStorePropertiesUpdated(true);
                              }}
                            />
                          ) : null}

                          {item?.pricings?.map(
                            (pricingProperty, pricingIndex) => {
                              const pricingDetailsProperty = pricingTypes?.find(
                                (pricingItem) =>
                                  pricingItem?.id ===
                                  pricingProperty?.pricing_type_id,
                              );

                              const storeCurrency = storeList.find(
                                (store) => store?.id === item?.store_id,
                              )?.currency_symbol;

                              const realSellingPrice =
                                rootFormDetails?.include_vat_in_price &&
                                rootFormDetails?.vat_enabled
                                  ? Number(pricingProperty?.price) /
                                    (1 + Number(rootFormDetails?.vat) / 100)
                                  : Number(pricingProperty?.price);

                              const discountAmount =
                                (Number(pricingProperty?.discount_rate) *
                                  realSellingPrice) /
                                100;

                              const discountedAmount =
                                realSellingPrice - discountAmount;

                              const vatAmount = rootFormDetails?.vat_enabled
                                ? (Number(discountedAmount) *
                                    Number(rootFormDetails?.vat)) /
                                    100 || 0
                                : 0;

                              return (
                                <>
                                  <div
                                    className={`${styles.priceSection} ${globalStyles.borderTopPurple} ${globalStyles.borderTop} mt-0 pt-3`}
                                    style={{ minWidth: "100%" }}
                                    key={pricingProperty?.uuid}
                                  >
                                    {/* pricing type */}
                                    <secondaryComponents.LoaderHelper
                                      isLoading={isLoadingPricingTypes}
                                      classNames={"mt-2"}
                                    >
                                      <div style={{ maxWidth: "180px" }}>
                                        <label htmlFor="">
                                          <span className="text-danger">*</span>

                                          <span>
                                            Price Type
                                            {item?.pricings?.length ===
                                            pricingIndex + 1 ? (
                                              <>
                                                {" ( "}
                                                <span
                                                  className="purple--text"
                                                  style={{
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    resetModalViews(
                                                      "isCreatePricing",
                                                    )
                                                  }
                                                >
                                                  Create new
                                                </span>
                                                {" )"}
                                              </>
                                            ) : null}
                                          </span>
                                        </label>
                                        <primaryComponents.SelectFieldV2
                                          name={`storeProperties.${storeIndex}.pricings.${pricingIndex}.pricing_type_id`}
                                          control={control}
                                          giveControl={false}
                                          value={{
                                            label:
                                              pricingDetailsProperty?.label,
                                            value: pricingDetailsProperty?.id,
                                          }}
                                          options={pricingTypes}
                                          nameKey="label"
                                          idKey="id"
                                          onChange={(value) => {
                                            const newStoreProperties = [
                                              ...storeProperties,
                                            ];
                                            newStoreProperties[
                                              storeIndex
                                            ].pricings[
                                              pricingIndex
                                            ].pricing_type_id = value;
                                            setStoreProperties(
                                              newStoreProperties,
                                            );
                                            setIsStorePropertiesUpdated(true);
                                          }}
                                          errorMessage={
                                            errors?.storeProperties?.[
                                              storeIndex
                                            ]?.pricings?.[pricingIndex]
                                              ?.pricing_type_id
                                          }
                                          isDisabled={
                                            (storeIndex > 0 &&
                                              rootFormDetails?.use_same_pricing) ||
                                            pricingIndex === 0
                                          }
                                          isSearchable={false}
                                        />
                                      </div>
                                    </secondaryComponents.LoaderHelper>

                                    {/* selling price */}
                                    <div style={{ position: "relative" }}>
                                      <primaryComponents.InputFieldV2
                                        name={`storeProperties.${storeIndex}.pricings.${pricingIndex}.price`}
                                        control={control}
                                        type="number"
                                        step={0.01}
                                        label={`Selling Amount (${
                                          storeCurrency
                                        })`}
                                        placeholder="0"
                                        classNames="white"
                                        isRequired
                                        isDisabled={
                                          storeIndex > 0 &&
                                          rootFormDetails?.use_same_pricing
                                        }
                                        value={pricingProperty?.price}
                                        errorMessage={
                                          errors?.storeProperties?.[storeIndex]
                                            ?.pricings?.[pricingIndex]?.price
                                        }
                                        onKeyUp={() =>
                                          errors?.storeProperties?.[storeIndex]
                                            ?.pricings?.[pricingIndex]?.price &&
                                          trigger(
                                            `storeProperties.${storeIndex}.pricings.${pricingIndex}.price`,
                                          )
                                        }
                                        onChange={({ target: { value } }) => {
                                          const newStoreProperties = [
                                            ...storeProperties,
                                          ];
                                          newStoreProperties[
                                            storeIndex
                                          ].pricings[pricingIndex].price =
                                            value;
                                          setStoreProperties(
                                            newStoreProperties,
                                          );
                                          setIsStorePropertiesUpdated(true);
                                        }}
                                      />
                                    </div>

                                    {/* discount */}
                                    <primaryComponents.PercentField
                                      label="Discount"
                                      name={`storeProperties.${storeIndex}.pricings.${pricingIndex}.discount_rate`}
                                      control={control}
                                      value={pricingProperty?.discount_rate}
                                      isDisabled={
                                        storeIndex > 0 &&
                                        rootFormDetails?.use_same_pricing
                                      }
                                      onChange={({ percentValue }) => {
                                        const newStoreProperties = [
                                          ...storeProperties,
                                        ];
                                        newStoreProperties[storeIndex].pricings[
                                          pricingIndex
                                        ].discount_rate = percentValue;
                                        setStoreProperties(newStoreProperties);
                                        setIsStorePropertiesUpdated(true);
                                      }}
                                      dividedValue={
                                        pricingProperty?.price === ""
                                          ? 0
                                          : realSellingPrice
                                      }
                                    />

                                    {pricingIndex > 0 ? (
                                      <div
                                        className="d-flex align-items-center my-auto"
                                        style={{
                                          minWidth: "fit-content",
                                          maxWidth: "fit-content",
                                        }}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn--outline-red"
                                          style={{
                                            height: "30px",
                                            width: "28px",
                                            padding: "0",
                                            borderRadius: "3px",
                                          }}
                                          onClick={() =>
                                            removePricingForStoreProperty(
                                              storeIndex,
                                              pricingIndex,
                                            )
                                          }
                                        >
                                          <img src={Icon.deleteIcon} alt="" />
                                        </button>
                                      </div>
                                    ) : null}
                                  </div>

                                  <div
                                    className="d-flex flex-wrap pb-2"
                                    style={{
                                      columnGap: "50px",
                                      rowGap: "15px",
                                      minWidth: "auto",
                                      maxWidth: "none",
                                    }}
                                  >
                                    {rootFormDetails?.vat_enabled && (
                                      <>
                                        <div>
                                          <h6>VAT Amount</h6>
                                          <p>
                                            {storeCurrency}
                                            {vatAmount.toFixed(2)}
                                          </p>
                                        </div>

                                        <div>
                                          <h6>Selling Price (VAT Exclusive)</h6>
                                          <p>
                                            {storeCurrency}
                                            {discountedAmount.toFixed(2)}
                                          </p>
                                        </div>

                                        <div>
                                          <h6>Selling Price (VAT Inclusive)</h6>
                                          <p>
                                            {storeCurrency}
                                            {(
                                              discountedAmount + vatAmount
                                            ).toFixed(2)}
                                          </p>
                                        </div>
                                      </>
                                    )}

                                    {!isEditMode ? (
                                      <div>
                                        <h6>Profit</h6>
                                        <p>
                                          {storeCurrency}
                                          {(
                                            discountedAmount - item?.cost_price
                                          ).toFixed(2)}
                                        </p>
                                      </div>
                                    ) : null}
                                  </div>
                                </>
                              );
                            },
                          )}
                        </div>

                        {/* use across */}

                        <div className={styles.useAcrossSection}>
                          <a
                            className="purple--text"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              addNewPricingForStoreProperty(storeIndex)
                            }
                          >
                            + Add another price option
                          </a>
                          {storeIndex === 0 ? (
                            <label
                              className="d-flex align-items-center"
                              style={{ cursor: "pointer" }}
                              htmlFor="useSamePricing"
                            >
                              <primaryComponents.Checkbox
                                name="useSamePricing"
                                id="useSamePricing"
                                isChecked={rootFormDetails?.use_same_pricing}
                                onChange={(value) => {
                                  setRootFormDetails((prevState) => ({
                                    ...prevState,
                                    use_same_pricing: value,
                                  }));
                                  if (value) {
                                    if (!rootFormDetails.has_variant)
                                      setIsStorePropertiesUpdated(true);
                                  }
                                }}
                              />
                              <span className="ml-2 mt-1">
                                Use this pricing properties across other stores
                              </span>
                            </label>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <h5 className="text-center my-4">
                  Please select stores to proceed with pricing
                </h5>
              )}
            </>
          )}
        </div>

        <MarketPlaceCreation
          isEditMode={isEditMode}
          rootFormDetails={rootFormDetails}
          setRootFormDetails={setRootFormDetails}
        />

        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto w-100 mt-4"}
          style={{ maxWidth: "300px" }}
          type="submit"
          form="productForm"
          isDisabled={isUpdatingProduct}
          isLoading={isUpdatingProduct}
          loadingText={isEditMode ? "Updating..." : "Creating..."}
        >
          {isEditMode ? "Update Product" : "Create Product"}
        </primaryComponents.Button>
      </form>

      {/* pricing form */}
      <secondaryComponents.Modal
        isActive={modalViews?.isCreatePricing}
        closeModal={() => resetModalViews("isCreatePricing", false)}
        width={400}
      >
        <secondaryComponents.CreatePricingType
          closeWidget={() => resetModalViews("isCreatePricing", false)}
        />
      </secondaryComponents.Modal>

      {/* unit form */}
      <secondaryComponents.Modal
        isActive={modalViews?.isCreateUnit}
        closeModal={() => resetModalViews("isCreateUnit", false)}
        width={400}
      >
        <secondaryComponents.ProductUnitForm
          closeWidget={() => resetModalViews("isCreateUnit", false)}
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={modalViews?.isWarning}
        closeModal={() => resetModalViews("isWarning", false)}
        width={500}
      >
        <WarningDialog
          closeModal={() => resetModalViews("isWarning", false)}
          title={"Pricing Warning"}
          handler={createOrUpdateProduct}
        >
          <PricingWarning detectedPricing={detectedPricing} />
        </WarningDialog>
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={showVatOverrideModal}
        closeModal={() => {
          setRootFormDetails((prev) => ({ ...prev, vat_enabled: false }));
          setShowVatOverrideModal(false);
          // Also programmatically check the "No" radio button
          // This is handled by setting vat_enabled: false in state
        }}
        width={500}
      >
        <WarningDialog
          closeModal={() => {
            setShowVatOverrideModal(false);
            setRootFormDetails((prev) => ({ ...prev, vat_enabled: false }));
          }}
          title={"Store VAT Exists"}
          handler={() => {
            setRootFormDetails((prev) => ({ ...prev, vat_enabled: true }));
            setShowVatOverrideModal(false);
          }}
          continueText="Continue"
          cancelText="Cancel"
        >
          <div style={{ padding: "16px", fontSize: "16px" }}>
            A store VAT already exists for this product under{" "}
            <b>
              {(rootFormDetails?.stores || [])
                .filter((s) => s.vat && Number(s.vat) > 0)
                .map((s) => s.label || s.name)
                .join(", ")}
            </b>
            .<br />
            <br />
            Would you like to proceed with creating a product VAT as well?
            <br />
            <span style={{ color: "#a00", fontWeight: 500 }}>
              Please note that once a product VAT is set, it will be used at
              checkout in SellMode instead of the store-level VAT.
            </span>
          </div>
        </WarningDialog>
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={modalViews?.isCreateSupplier}
        closeModal={() => resetModalViews("isCreateSupplier", false)}
        width="600px"
      >
        <secondaryComponents.SupplierForm
          closeWidget={() => resetModalViews("isCreateSupplier", false)}
        />
      </secondaryComponents.Modal>
    </>
  );
};
export default SingleProductForm;
